import * as types from './actionTypes';

export const loadVote = (link = null) => {
    return {
        type: types.VOTE_LOAD,
        link,
    };
};
